import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { ERROR } from '../../../utils/constants';

import { requestViewBuyerListing, requestBookmarkProductListing } from '../../../api/product/product.actions';
import { requestExpressInterest } from '../../../api/contract/contract.actions';
import { setBuyerListing } from '../../../slices/product/product.slice';
import { addSystemNotice } from '../../../slices/system/system.slice';
import { requestVerifyUser } from '../../../api/verification/verification.actions';
import { setProduct } from '../../../slices/market-buzz/market-buzz.slice';

import BuyerListingPage from '../../../components/screens/market/buyer-listing-page/BuyerListingPage';

const BuyerListingPageContainer = () => {
  const { buyerListing } = useSelector(({ product }) => product);
  const { userVerification, profile } = useSelector(({ party }) => party);
  const currencyCode = useSelector(({ currency }) => currency.currencyCode);

  const [bookmarked, setBookmarked] = useState(false);

  const { productExternalReference } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    if (productExternalReference) {
      dispatch(requestViewBuyerListing({ productExternalReference }));
    }

    return () => dispatch(setBuyerListing(undefined));
  }, [dispatch, productExternalReference]);

  useEffect(() => {
    if (buyerListing) {
      setBookmarked(buyerListing.bookmarked);
    }
  }, [buyerListing]);

  useEffect(() => {
    dispatch(requestVerifyUser({}));
  }, [dispatch]);

  if (!buyerListing) return null;

  const updateBookmark = () => {
    dispatch(
      requestBookmarkProductListing({
        productExternalReference: productExternalReference,
        type: 'buyer',
        onSuccess: () => setBookmarked(!bookmarked),
      })
    );
  };

  const expressInterest = () => {
    if (!userVerification) {
      dispatch(addSystemNotice({ type: ERROR, message: 'An error occurred when assessing user verification' }));
      return;
    }

    if (!userVerification.generalVerification) {
      dispatch(
        addSystemNotice({
          type: ERROR,
          message: 'Not verified as buyer/supplier. Please navigate to verification in settings',
        })
      );
      return;
    }

    if (userVerification.brokerCompany && !userVerification.brokerVerification) {
      dispatch(
        addSystemNotice({ type: ERROR, message: 'Not verified as broker. Please navigate to verification in settings' })
      );
      return;
    }
    dispatch(
      requestExpressInterest({
        productExternalReference,
        onSuccess: (contractExternalReference) => navigate(`/shop/deal-room/${contractExternalReference}`),
      })
    );
  };

  const buzzProduct = (product) => {
    dispatch(setProduct(product));
    navigate('/market/market-buzz/create');
  };

  return (
    <BuyerListingPage
      buyerListing={buyerListing}
      updateBookmark={updateBookmark}
      bookmarked={bookmarked}
      expressInterest={expressInterest}
      isCreator={profile?.organisationExternalReference === buyerListing.creatorExternalReference}
      buzzProduct={buzzProduct}
      currencyCode={currencyCode}
    />
  );
};

export default BuyerListingPageContainer;
